import { Constants } from "../products/productsTypes";
import { ProductsMdl } from "../../Modal/Products";
import { action } from "typesafe-actions";
export function storeProducts(payload: ProductsMdl[], loadMore?: boolean) {
  return action(Constants.SET_PRODUCTS, {
    products: payload,
    loadMore,
  });
}

export function setRSDAvailable(RSDAvailable: boolean) {
  return action(Constants.SET_PRODUCT_RSDAVAILABLE, {
    RSDAvailable,
  });
}

export function storeProductCount(count: number) {
  return action(Constants.SET_PRODUCT_COUNT, {
    count,
  });
}

export function storeProduct(payload: ProductsMdl[]) {
  return action(Constants.SET_PRODUCT, {
    product: payload,
  });
}
export function storeRelProducts(payload: ProductsMdl[]) {
  return action(Constants.SET_REL_PRODUCTS, {
    Relproducts: payload,
  });
}
export function storeCartOrderProduct(payload: ProductsMdl[]) {
  return action(Constants.SET_CART_PRODUCT_ORDER, {
    CartProductOrder: payload,
  });
}
export function storeAddedCartProduct(payload: any) {
  return action(Constants.SET_ADDED_CART_PRODUCT, {
    CartData: payload,
  });
}

//storeCartDetails
export function storeCartDetails(payload: any) {
  return action(Constants.SET_CART_DATA, {
    AddedCartProduct: payload,
  });
}
export function CartOrderData(payload: any) {
  return action(Constants.CART_ORDER_DATA, {
    CartOrderData: payload,
  });
}

export function storeSearchData(payload: any, loadMore?: boolean) {
  return action(Constants.SET_SEARCH_DATA, {
    searchData: payload,
    loadMore
  });
}
//storeSearchCount
export function storeSearchCount(payload: any) {
  return action(Constants.SET_SEARCH_COUNT, {
    searchDataCount: payload,
  });
}

export function previousLocation(payload: any) {
  return action(Constants.PREVIOUS_LOCATION_URL, {
    previousLocation: payload,
  });
}
//storeSecondaryImage
export function storeSecondaryImage(payload: any) {

  return action(Constants.SECONDARY_iMAGE_URL, {
    secondaryImageUrl: payload,
  });
}
// /storeProductReleaseEnumValue
export function storeProductReleaseEnumValue(payload: any) {
  return action(
    Constants.SET_PRODUCT_RELEASES_ENUM_VALUE, {
    productReleseasValue: payload
  })
}

export function storeReleasesEnumsValue(payload: any) {

  return action(Constants.SET_PRODUCT_RELEASES_ENUM_VALUES, {
    releases_enums_values: payload,
  });
}
export function storeredirectPath(payload: any) {

  return action(Constants.SET_REDIRECT_PATH_FROM_RELAESES, {
    store_redirect_path: payload,
  });
}
// /storeProductReleaseEnumValue
export function storeLabelsValue(payload: any) {
  return action(
    Constants.SET_LABLE_VALUE, {
    label_value: payload
  })
}